import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Tab1Gray from "../../assets/icons/Alignicon.svg";
import Tab1Black from "../../assets/icons/Alignicon1.svg";
import Tab3Gray from "../../assets/icons/Columnsicon.svg";
import Tab3Black from "../../assets/icons/Columnsicon1.svg";
import Tab2Black from "../../assets/icons/Gridicon.svg";
import Tab2Gray from "../../assets/icons/Gridicon1.svg";
import AddIcon from "../../assets/icons/addicon.svg";
import pro_Project from "../../assets/icons/pro_Project.svg";
import Loader from "../../components/Dailogs/Loader";
import Header from "../../layouts/Header";
import "../../assets/styles/local/Project.css";
import { useSelector } from "react-redux";
import ProjectKanBan from "./ProjectKanban";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import ProjectBBList from "./ProjectBBList";
import ProjectList from "./ProjectList";
import upArrow from "../../assets/icons/upArrow.png";
import { Tooltip, Progress, FloatButton } from "antd";

const Project = () => {
  const history = useHistory();
  const roleAccess = window.localStorage.getItem("roleid");
  const packageId = window.localStorage.getItem("packageId");

  const location = useLocation();
  const [activeTab, setActiveTab] = useState(
    window.localStorage.getItem("activeTab") || 1,
  );
  const [query, setQuery] = useState("");
  const [apimessage, setApimessage] = useState("");
  const [showLoader, setShowLoader] = useState(true);
  const [projectListTranslation, setProjectListTranslation] = useState({});
  const t = (key) => projectListTranslation?.[key] || "";

  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
    }
  }, [getAppSideNavOptions]);

  const [isPlusPackage, setIsPlusPackage] = useState(false);

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsPlusPackage(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PLUS,
        ),
      );
    }
  }, [getAppSideNavOptions]);

  useEffect(() => {
    fetchScreenTranslations("Project-List").then((res) => {
      setProjectListTranslation(res);
      setShowLoader(false);
    });
  }, []);

  useEffect(() => {
    setActiveTab(window.localStorage.getItem("activeTab") || 1);
  }, [location.pathname]);

  useEffect(() => {
    const storedTab = parseInt(window.localStorage.getItem("activeTab")) || 1;
    setActiveTab(storedTab);
  }, [location.pathname]);

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    window.localStorage.setItem("activeTab", tabIndex); // Persist active tab
  };

  // for sort by
  const [shortByArrow, setShortByArrow] = useState(false);
  const [showShortDrop, setShowShortDrop] = useState(false);
  const [sortedLabel, setSortedLabel] = useState("Project ID");
  const [sortedValue, setSortedValue] = useState("ProjectID");

  const sortByOption = [
    { label: t("Project Id"), value: "ProjectID" },
    { label: t("Project Name"), value: "ProjectName" },
    { label: t("Client"), value: "Client" },
    { label: t("Work Address"), value: "WorkAddress" },
    // {
    //   label: projectListTranslation[64]?.translation,
    //   value: "Project Manager",
    // },
    // {
    //   label: projectListTranslation[63]?.translation,
    //   value: "Completion Date",
    // },
    // {
    //   label: projectListTranslation[99]?.translation,
    //   value: "Assig. Probability",
    // },
  ];

  return (
    <>
      <Header
        setQuery={setQuery}
        leftComponent={
          <div
            style={{
              color: "#333333",
              fontSize: "16px",
              lineHeight: "27px",
              fontWeight: "bold",
            }}
          >
            {/* Projects */}
            {t("Projects")}
          </div>
        }
      />

      {showLoader === true ? (
        <div
          className="text-center "
          style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
        >
          <Loader />
        </div>
      ) : (
        <div className="container-fluid">
          <>
            {apimessage && (
              <h1 className="text-center text-danger">{apimessage}</h1>
            )}
            <div className="d-flex justify-content-between items-center flex-wrap mx-4 ">
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  flexShrink: "0",
                  alignItems: "center",
                }}
                className="alignCenter"
              >
                {packageId !== process.env.REACT_APP_IS_PLUS && (
                  <Tooltip title="List view" color={""}>
                    <img
                      className="alignicon cursor-pointer"
                      src={activeTab === 1 ? Tab1Black : Tab1Gray}
                      alt=""
                      // onClick={() => {
                      //   setActiveTab(1);
                      //   window.localStorage.setItem("activeTab", 1);
                      // }}
                      onClick={() => handleTabClick(1)}
                    />
                  </Tooltip>
                )}

                <Tooltip title="Tile view" color={""}>
                  <img
                    className="gridicon mx-3 cursor-pointer"
                    src={activeTab == 2 ? Tab2Black : Tab2Gray}
                    alt=""
                    // onClick={() => {
                    //   setActiveTab(2);
                    //   window.localStorage.setItem("activeTab", 2);
                    // }}
                    onClick={() => handleTabClick(2)}
                  />
                </Tooltip>

                {(roleAccess !== process.env.REACT_APP_IS_VIEWER &&
                  isPlusPackage) ||
                  (isBuildingBlock && (
                    <img
                      className="columnsicon cursor-pointer d-none"
                      src={activeTab == 3 ? Tab3Black : Tab3Gray}
                      alt=""
                      // onClick={() => {
                      //   setActiveTab(3);
                      //   window.localStorage.setItem("activeTab", 3);
                      // }}
                      onClick={() => handleTabClick(3)}
                    />
                  ))}
              </div>

              {activeTab === 1 && (
                <sortSection
                  className="d-flex gap-3 w-25 d-non-e"
                  style={{ position: "relative" }}
                >
                  <p className="sortBy">
                    {/* Sort by */}
                    {t("Sort By")}
                  </p>
                  <img
                    className={
                      shortByArrow
                        ? "downSortArrow mt-1 pointer"
                        : "upSortArrow mt-1 pointer"
                    }
                    src={upArrow}
                    alt=""
                    onClick={() => {
                      setShortByArrow(!shortByArrow);
                    }}
                  />
                  <p
                    className="datetext pointer"
                    onClick={() => setShowShortDrop(!showShortDrop)}
                  >
                    {sortedValue ? sortedLabel : "Select"}
                  </p>

                  <div
                    className="sortDropDiv p-3"
                    style={{
                      transform: showShortDrop ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                    }}
                  >
                    {sortByOption.map((item, index) => {
                      return (
                        <div
                          className={
                            sortedValue === item.value
                              ? "datetext pointer"
                              : "pointer"
                          }
                          onClick={() => {
                            setSortedLabel(item.label);
                            setSortedValue(item.value);
                            setShowShortDrop(false);
                          }}
                        >
                          <p className="d-flex gap-">
                            {item.label}
                            {sortedValue === item.value && (
                              <p className="mb-0 ps-3">✓</p>
                            )}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </sortSection>
              )}
              <div
                className={
                  roleAccess === process.env.REACT_APP_IS_VIEWER
                    ? "hidden"
                    : "btnHoverDiv pointer"
                }
                onClick={() => {
                  history.push("/addProject", "/project");
                }}
              >
                <div className="d-flex justify-content-center addProject">
                  <img
                    className="projectIcon imgWidth me-4"
                    src={pro_Project}
                    alt=""
                  />
                  <img
                    className="proAddIcon imgWidth me-4"
                    src={AddIcon}
                    alt=""
                  />
                  <p className="pt-3 pe-3 hide-on-mobile">
                    {/* Add Project */}
                    {t("Add Project")}
                  </p>
                </div>
              </div>
            </div>

            {/* project-list */}
            {activeTab === 1 && (
              <ProjectList
                query={query}
                setShowLoader={() => setShowLoader(false)}
                shortByArrow={shortByArrow}
                sortedValue={sortedValue}
                activeTab={activeTab}
              />
            )}
          </>
          {activeTab === 3 && <ProjectKanBan query={query} />}
        </div>
      )}
      {activeTab === 2 && (
        <ProjectBBList
          query={query}
          setShowLoader={() => setShowLoader(false)}
        />
      )}
    </>
  );
};

export default Project;
